import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptor, HttpHandler, HttpRequest,
         HttpEvent, HttpClient, HttpResponse,
         HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './Services/auth';
import 'rxjs/add/operator/do';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private inj: Injector) {}

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

              const auth = this.inj.get(AuthService);
              const token = auth._getToken();

              if (token) {
                const cloned = req.clone({
                  headers: req.headers.set(
                    "Authorization",
                    "Bearer " + token)
                });

                return next.handle(cloned).do(
                  (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                      // all good
                    }
                  }, (err: any) => {

                    if (err instanceof HttpErrorResponse) {

                      if (err.status === 401) {

                        auth._rmToken();
                        // Looks like token has expired. Tough.
                        // Continue with original request
                        return next.handle(req);
                      } else {
                        // TODO: what?
                      }
                    }
                  });
              } else {
                return next.handle(req);
              }
            }
}



// WEBPACK FOOTER //
// ./src/app/interceptor.ts